<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row d-flex justify-content-between">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4><i class="fa-solid fa-robot" aria-hidden="true" style="font-size:21px;margin-right:8px;color:var(--iq-primary);"></i>{{ cvCardTitle }}</h4>
          </div>
          <div class="d-flex align-items-center pl-2 pl-sm-0" style="gap:8px;">
            <b-button class="right-align-sm" variant="primary" @click="wrkAgentAdd()">{{ cvbtnAddNew }}</b-button>
          </div>
        </div>

        <!-- Filters -->
        <div class="iq-card row p-3">
          <b-col>
            <b-row class="col-12 col-xl-10">
              <b-col class="col-12 mb-3">
                <b-form-input id="search" v-model="whereFilter.search_param" type="search" :placeholder="cvSearchText" @input="searchFromBackend"/>
              </b-col>
            </b-row>

            <b-row class="col-12 mb-2">
              <b-col class="mb-2 col-12 col-sm-6">
                <select
                  v-if="modules.length > 0"
                  v-model="whereFilter.module_name"
                  class="form-control"
                  title="Module List"
                  @change="setModuleName"
                >
                  <option :value="null">All Modules</option>
                  <option v-for="(module, index) in modules" :key="index" :value="module.mod_name">{{ module.mod_name }}</option>
                </select>
              </b-col>
            </b-row>
          </b-col>
        </div>
        <!-- Table -->
        <div class="iq-card row p-3 d-flex align-items-center" :style="{ minHeight: (!wrkAgentObjList || wrkAgentObjList.length === 0) ? '400px' : 'auto'}">
          <b-col v-if="wrkAgentObjList && Array.isArray(wrkAgentObjList) && wrkAgentObjList.length > 0" md="12">
            <b-table
              hover
              responsive
              :items="wrkAgentObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
            >
              <template v-slot:cell(id)="data">
                <span style="display:block;width:50px">
                  {{ wrkAgentObjList.indexOf(data.item) + 1 }}
                </span>
              </template>

              <template v-slot:cell(agent_id)="data">
                <span :title="data.item.agent_id">{{ data.item.agent_id }}</span>
              </template>

              <template v-slot:cell(agent_name)="data">
                <span :title="data.item.agent_name">
                  {{ data.item.agent_name || "-" }}
                </span>
                <br>
                <b-row class="mt-2">
                  <b-col>
                    <b-button title="Edit Agent" variant="mr-1 mb-1 actionIcon" size="sm" @click="wrkAgentEdit('MODAL', data.item)">
                      <i class="ri-ball-pen-fill m-0 font-size-20"></i>
                    </b-button>
                    <b-button title="View Agent" variant="actionIcon" size="sm" @click="wrkAgentView(data.item)">
                      <i class="fa fa-eye m-0 font-size-20"></i>
                    </b-button>
                    <b-button title="View Sub Agents" style="border: none;" class="bg-transparent p-0 pl-3" @click="openApp(data?.item?.agent_id, 'wrk_sub_agent_list')"><i class="font-size-18 fa-solid fa-robot text-black"></i></b-button>
                  </b-col>
                </b-row>
              </template>

              <template v-slot:cell(action)="data">
                {{ data.item.action ? data.item.action.length > 100 ? data.item.action.substring(0, 100) + "..." : data.item.action : "-"}}
              </template>

              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormatDDMMYY }}
              </template>
            </b-table>

            <div class="d-flex align-items-center mt-3 py-3">
              <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
                <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
              </b-col>
            </div>
          </b-col>
          <b-col v-else-if="wrkAgentObjList && Array.isArray(wrkAgentObjList) && wrkAgentObjList.length === 0">
            <h5 class="text-secondary text-center">
              No matching agents found.
            </h5>
          </b-col>
          <b-col v-else class="text-center py-5">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <h5 class="mt-3 text-primary">Loading agents...</h5>
            <p class="text-muted mb-0">
              Please wait while agent records are being loaded.
            </p>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!-- Add Modal -->
    <b-modal
      v-model="showModelWrkAgentAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <wrkAgentAdd :propModules="modules" :propOpenedInModal="true" @emitCloseWrkAgentAddModal="closeWrkAgentAddModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkAgentAddModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      v-model="showModelWrkAgentEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <wrkAgentEdit :propModules="modules" :propOpenedInModal="true" :propWrkAgentObj="wrkAgentEditObj" @emitCloseWrkAgentEditModal="closeWrkAgentEditModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkAgentEditModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <!-- View Modal -->
    <b-modal
      v-model="showModelWrkAgentView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <wrkAgentView :propWrkAgentObj="wrkAgentViewObj"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkAgentViewModal">{{ cvbtnModalCancel }}</b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import wrkAgentAdd from "./WrkAgentAdd.vue"
import wrkAgentEdit from "./WrkAgentEdit.vue"
import wrkAgentView from "./WrkAgentView.vue"
import { socialvue } from "../../../config/pluginInit.js"
import { WrkAgentApiObj } from "../../../FackApi/api/wrkAgent.js"
import { moduleApiObj } from "../../../FackApi/api/module.js"

export default {
  name: "wrkAgentList",
  components: {
    wrkAgentAdd,
    wrkAgentEdit,
    wrkAgentView
  },
  data () {
    return {
      cvCardTitle: "Workflow Agents",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvEditModalHeader: "Edit Agent",
      cvAddModalHeader: "Add Agent",
      cvViewModalHeader: "View Agent",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Agent",
      showModelWrkAgentAdd: false,
      showModelWrkAgentEdit: false,
      showModelWrkAgentView: false,
      sortBy: "agent_name",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Agent Name", key: "agent_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Agent Id", key: "agent_id", class: "text-left align-text-top w-350px", sortable: true },
        { label: "Module Name", key: "module_name", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Action", key: "action", class: "text-left align-text-top w-350px", sortable: true },
        { label: "App Domain", key: "app_domain", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top w-200px", sortable: true }
      ],
      wrkAgentObjList: null,
      wrkAgentEditObj: null,
      wrkAgentViewObj: null,
      filter: null,
      filterOn: [],
      currentBatchNo: 1,
      dataPerPage: 25,
      totalDataCount: 0,
      modules: [],
      whereFilter: {
        search_param: "",
        module_name: null
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    socialvue.index()

    this.wrkAgentList()
    this.moduleList()
  },
  methods: {
    /**
     * searchFromBackend
     */
    searchFromBackend () {
      if (this.whereFilter.search_param.length <= 2 && this.whereFilter.search_param.length !== 0) {
        return
      }
      this.currentBatchNo = 1
      this.wrkAgentList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.wrkAgentList(true)
    },
    /**
     * wrkAgentList
     */
    async wrkAgentList (loadViaLoadMore = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage

        let wrkAgentListResp = await WrkAgentApiObj.wrkAgentList(this, this.whereFilter)

        if (wrkAgentListResp.resp_status) {
          if (!loadViaLoadMore) {
            this.wrkAgentObjList = [...wrkAgentListResp.resp_data.data]
          }
          else {
            this.wrkAgentObjList = [...this.wrkAgentObjList, ...wrkAgentListResp.resp_data.data]
          }

          this.totalDataCount = wrkAgentListResp.resp_data_total_count
        }
        else {
          this.toastMsg = wrkAgentListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.wrkAgentObjList = []
        }
      }
      catch (err) {
        console.error("Exception occurred at wrkAgentList() and Exception:", err.message)
        this.toastMsg = "Failed to fetch agents. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.wrkAgentObjList = []
      }
    },
    /**
     * wrkAgentAdd
     */
    wrkAgentAdd (type = "MODAL") {
      if (type === "FULLPAGE") {
        this.$router.push("/wrk_agent_add")
      }
      else {
        this.showModelWrkAgentAdd = true
      }
    },
    /**
     * wrkAgentEdit
     */
    wrkAgentEdit (type, item) {
      if (type === "FULLPAGE") {
        this.$router.push("/wrk_agent_edit/" + item.agent_id)
      }
      else {
        this.wrkAgentEditObj = {
          agent_id: item.agent_id,
          agent_name: item.agent_name,
          agent_desc: item.agent_desc,
          module_name: item.module_name,
          action: item.action,
          agent_app_domain: item.app_domain
        }
        this.showModelWrkAgentEdit = true
      }
    },
    /**
     * wrkAgentView
     */
    wrkAgentView (item) {
      this.wrkAgentViewObj = item
      this.showModelWrkAgentView = true
    },
    /*
     * closeWrkAgentAddModal
     */
    closeWrkAgentAddModal () {
      this.showModelWrkAgentAdd = false
      this.wrkAgentList()
    },
    /*
    * closeWrkAgentEditModal
    */
    closeWrkAgentEditModal () {
      this.showModelWrkAgentEdit = false
      this.wrkAgentList()
    },
    /*
    * closeWrkAgentViewModal
    */
    closeWrkAgentViewModal () {
      this.showModelWrkAgentView = false
    },
    /*
     * moduleList
     */
    async moduleList () {
      try {
        let moduleListResp = await moduleApiObj.moduleList(this)
        if (moduleListResp.resp_status) {
          this.modules = moduleListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at moduleList() and Exception:", err.message)
      }
    },
    /*
     * setModuleName
     */
    setModuleName () {
      this.currentBatchNo = 1
      this.wrkAgentList()
    },
    /**
     * openApp
     */
    openApp (agentId, path) {
      if (path && agentId) {
        this.$router.push(`/${path}/${agentId}`)
      }
    }
  }
}
</script>
